import React from 'react';
import { Operation } from '../../Transactions.types';
import { OperationListItem } from '../OperationListItem';
import * as S from './OperationsList.styles';

interface OperationsListProps {
  operations: Operation[];
  onShowDetails: (operation: Operation) => void;
  loadMoreSkeleton?: React.ReactNode;
}

export function OperationsList({
  operations,
  onShowDetails,
  loadMoreSkeleton,
}: OperationsListProps) {
  return (
    <S.Container>
      {operations.map(operation => (
        <OperationListItem
          key={operation.id}
          operation={operation}
          onShowDetails={onShowDetails}
        />
      ))}

      {loadMoreSkeleton}
    </S.Container>
  );
}
